// import { createContext, useContext, useState } from 'react';

// // Create a context
//  export const GlobalStateContext = createContext();

// // Create a provider component
// export function GlobalStateProvider({ children }) {
//   const [globalState, setGlobalState] = useState(/* initial state */);
//   // const [buState, setBuState] = useState(-1);
//   const [selectedBU, setSelectedBU] = useState('ALL');
//   const [buName,setBuName] = useState("");
//   const [openFullScreen, setOpenFullScreen] =  useState(false);

//   return (
//     <>
//       <GlobalStateContext.Provider value={{ globalState, setGlobalState, selectedBU,setSelectedBU , buName, setBuName, openFullScreen, setOpenFullScreen}}>
//         {children}
//       </GlobalStateContext.Provider>
//     </>
//   );
// }

// // Create a custom hook to access the context
// // export function useGlobalState() {
// //   return useContext(GlobalStateContext);
// // }

import { createContext, useContext, useState } from 'react';

// Create a context
export const GlobalStateContext = createContext();

// Create a provider component
export function GlobalStateProvider({ children }) {
  const [globalState, setGlobalState] = useState(/* initial state */);
  // const [buState, setBuState] = useState(-1);
  const [selectedBU, setSelectedBU] = useState('ALL');
  const [buName, setBuName] = useState('');
  const [openFullScreen, setOpenFullScreen] = useState(false);
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);

  return (
    <>
      <GlobalStateContext.Provider
        value={{
          globalState,
          setGlobalState,
          selectedBU,
          setSelectedBU,
          buName,
          setBuName,
          openFullScreen,
          setOpenFullScreen,
          selectedGroupIds,
          setSelectedGroupIds,
        }}
      >
        {children}
      </GlobalStateContext.Provider>
    </>
  );
}
